var DataZoomView = require("./DataZoomView");

var _default = DataZoomView.extend({
  type: 'dataZoom.select'
});

module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataZoom/SelectZoomView.js
// module id = 758
// module chunks = 2